<template>
  <div id="modalSolicitud" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Editar solicitud</h2>
          <div class="acciones-modal">
            <button
              :disabled="!PuedeGuardar"
              type="button"
              class="btn btn-success"
              @click="clickGuardar()"
            >
              <font-awesome-icon v-if="!guardando" :icon="Icons.ACEPTAR" />
              <div
                v-else
                id="indicador-guardado"
                class="spinner-border"
                role="status"
              ></div>
            </button>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body">
          <!-- Parte de comercio -->
          <h3>Comercio</h3>
          <!-- Nombre de comercio -->
          <div class="form-floating mb-3">
            <input
              :disabled="guardando"
              v-model="item.comercio.name"
              id="nombreComercio"
              placeholder="Comercio X"
              type="text"
              class="form-control"
            />
            <label for="nombreComercio">Nombre de comercio</label>
          </div>
          <!-- CUIT -->
          <div class="form-floating mb-3">
            <input
              :disabled="guardando"
              v-model="item.comercio.cuit"
              id="cuit"
              placeholder="##-12345678-X"
              type="text"
              class="form-control"
            />
            <label for="cuit">CUIT</label>
          </div>
          <!-- Dirección -->
          <div class="form-floating mb-3">
            <input
              :disabled="guardando"
              v-model="item.comercio.address"
              id="direccion"
              placeholder="Calle ejemplo 123"
              type="text"
              class="form-control"
            />
            <label for="direccion">Dirección</label>
          </div>
          <!-- Email -->
          <div class="form-floating mb-3">
            <input
              :disabled="guardando"
              v-model="item.comercio.email"
              id="email"
              placeholder="nombre@ejemplo.com"
              type="email"
              class="form-control"
            />
            <label for="email">Email</label>
          </div>
          <!-- Logo -->
          <div class="logo-flotante mb-3">
            <label>Logo</label>
            <CargadorImagen
              ref="cargadorImagen"
              v-on:agregado="logoAgregado"
              v-on:eliminado="logoEliminado"
            />
            <p v-show="Editando" class="info-bajo-input">
              Si no se elige un logo, se mantendrá el actual
            </p>
          </div>
          <!-- Provincia -->
          <div class="select-flotante mb-3">
            <label>Provincia</label>
            <select
              v-model="item.comercio.provincia.id"
              @change="provinciaCambiada($event)"
              required
              class="custom-select"
            >
              <option selected>Provincia</option>
              <option
                v-for="prov in provinciaList"
                v-bind:key="prov.id"
                v-bind:value="prov.id"
              >
                {{ prov.nombre }}
              </option>
            </select>
          </div>
          <!-- Localidad -->
          <div class="select-flotante mb-3">
            <label>Localidad</label>
            <list-select
              @select="localidadCambiada"
              :list="localidades"
              :selectedItem="ObjetoLocalidad"
              required
              optionValue="id"
              optionText="nombre"
              placeholder="Localidad"
              autocomplete="off"
            ></list-select>
          </div>
          <!-- Teléfono -->
          <div class="form-floating mb-3">
            <input
              :disabled="guardando"
              v-model="item.comercio.phone"
              id="phone"
              placeholder="123456789"
              type="text"
              class="form-control"
            />
            <label for="phone">Teléfono</label>
          </div>

          <!-- Beneficio -->
          <div v-if="item.beneficio">
            <h3>Beneficio</h3>
            <!-- Nombre de beneficio -->
            <div class="form-floating mb-3">
              <input
                :disabled="guardando"
                v-model="item.beneficio.name"
                id="beneficioName"
                placeholder="Ingrese un nombre"
                type="text"
                class="form-control"
              />
              <label for="beneficioName">Nombre de beneficio</label>
            </div>
            <!-- Porcentaje de descuento -->
            <div class="form-floating mb-3">
              <input
                :disabled="guardando"
                v-model="item.beneficio.discountPercentage"
                id="discountPercentage"
                placeholder="XX"
                type="number"
                class="form-control"
              />
              <label for="discountPercentage">Porcentaje de Descuento</label>
            </div>
            <!-- Categoría -->
            <div class="select-flotante mb-3">
              <label>Categoría</label>
              <select
                v-model="categoriaId"
                @change="categoriaSeleccionada($event)"
                id="categoria"
                class="custom-select"
              >
                <option v-bind:key="null" v-bind:value="null">Categoría</option>
                <option
                  v-for="cat in categorias"
                  v-bind:key="cat.id"
                  v-bind:value="cat.id"
                >
                  {{ cat.name }}
                </option>
              </select>
            </div>
            <!-- Sub Categoría -->
            <div class="select-flotante mb-3">
              <label>Sub Categoría</label>
              <select
                class="custom-select"
                v-model="item.beneficio.subcategoria.id"
                @change="subcategoriaSeleccionada($event)"
              >
                <option v-bind:key="null" v-bind:value="null">
                  Sub Categoría
                </option>
                <option
                  v-for="sub in subcategoriaList"
                  v-bind:key="sub.id"
                  v-bind:value="sub.id"
                >
                  {{ sub.name }}
                </option>
              </select>
            </div>
            <!-- Permite invitado -->
            <div class="form-check mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="defaultCheck1"
                v-model="item.beneficio.allowsVisita"
              />
              <label class="form-check-label" for="defaultCheck1">
                Permite invitado
              </label>
            </div>
            <!-- Días habilitados -->
            <week-day-picker
              v-model="item.beneficio.diaHabilitadoList"
              class="mb-3"
            >
              <template slot="label">Días habilitados</template>
            </week-day-picker>
            <!-- Medio de pago -->
            <div class="form-floating mb-3">
              <input
                :disabled="guardando"
                v-model="item.beneficio.payMethod"
                id="medioPago"
                placeholder="Efectivo y Tarjetas"
                type="text"
                class="form-control"
              />
              <label for="medioPago">Medio de pago</label>
            </div>
          </div>
          <div v-else>
            Esta solicitud no tiene beneficio
          </div>

          <p v-if="!!DatosFaltantes" class="info-bajo-input">
            <i>Falta {{ DatosFaltantes }}</i>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const bootstrap = require("bootstrap");

import { environment } from "../../../environments/environment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ListSelect } from "vue-search-select";

import { Api } from "../../../api";
import CargadorImagen from "../../util/CargadorImagen";
import { Carpetas, Icons as IconConstants } from "../../../constants";
import { EstadoLogo } from "../../../data/enums";
import { Util } from "../../../util";
import WeekDayPicker from "../../util/WeekDayPicker.vue";

import { SolicitudComercioFacade as Facade } from "../../../service/admin/solicitud-comercio/solicitud-comercio.facade";

/** Cuando se cerró el modal */
const EVENTO_CERRADO = "cerrado";
/** Cuando se terminó de crear */
const EVENTO_CREADO = "creado";
/** Cuando se terminó de editar */
const EVENTO_EDITADO = "editado";

// Usado para realizar copias profundas y para que las computed properties funcionen correctamente
// a la hora de limpiar los datos del beneficio solo hay que hacer copiaProfunda de este objeto
const ITEM_LIMPIO = {
  beneficio: {
    allowsVisita: null,
    subcategoria: {
      id: undefined,
      name: undefined
    }
  },
  comercio: {
    id: null,
    localidad: {
      id: undefined,
      name: undefined
    },
    provincia: {
      id: undefined,
      name: undefined
    }
  }
};

export default {
  components: {
    FontAwesomeIcon,
    ListSelect,

    CargadorImagen,
    WeekDayPicker
  },
  data() {
    return {
      archivoLogo: null,
      categorias: [],
      editando: false,
      /**Usado para saber si hay que guardar el logo */
      estadoLogo: EstadoLogo.vacio,
      guardando: false,
      categoriaId: null,
      item: Util.copiaProfunda(ITEM_LIMPIO),
      localidades: [],
      modal: null,
      provinciaList: [],
      subcategoriaList: [],
      token: ""
    };
  },
  computed: {
    /**Dirección de la carpeta de logos */
    CarpetaLogos() {
      return environment.API_URL + Carpetas.LOGOS;
    },
    /**Devuelve una cadena con los datos que faltan */
    DatosFaltantes() {
      let cadena = "";

      if (!this.item.comercio.name)
        cadena = Util.agregarACadenaConComa(cadena, "nombre de comercio");

      if (!this.item.comercio.logoUrl && !this.archivoLogo) {
        cadena = Util.agregarACadenaConComa(cadena, "logo");
      }

      if (!this.item.comercio.email)
        cadena = Util.agregarACadenaConComa(cadena, "email");

      if (!this.item.comercio.phone)
        cadena = Util.agregarACadenaConComa(cadena, "teléfono");

      if (!this.item.comercio.localidad?.id)
        cadena = Util.agregarACadenaConComa(cadena, "localidad");

      if (this.item.beneficio) {
        if (!this.item.beneficio.name) {
          cadena = Util.agregarACadenaConComa(cadena, "nombre de beneficio");
        }

        if (!this.item.beneficio.discountPercentage) {
          cadena = Util.agregarACadenaConComa(
            cadena,
            "porcentaje de descuento"
          );
        }

        if (!this.item.beneficio.subcategoria?.id) {
          cadena = Util.agregarACadenaConComa(cadena, "subcategoría");
        }
      }

      return cadena;
    },
    Editando() {
      return this.editando;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    /** Objeto de localidad actual */
    ObjetoLocalidad() {
      return this.localidades.find(
        l => l.id == this.item.comercio.localidad.id
      );
    },
    PuedeGuardar() {
      return this.item && !this.guardando && !this.DatosFaltantes;
    }
  },
  created() {
    this.token = localStorage.getItem("token");

    Api.Localidad.getProvincias().then(response => {
      this.provinciaList = response.data;
    });

    Api.Categoria.getTodas().then(response => {
      this.categorias = response.data;
    });
  },
  mounted() {
    const opcionesModal = {};
    this.modal = new bootstrap.Modal(
      document.getElementById("modalSolicitud"),
      opcionesModal
    );
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    /**
     * @param {object} item Item editado, si no se pasa, se abre en modo creación
     */
    EventoAbrir(item = null) {
      if (item) {
        this.editando = true;
        this.iniciarEdicion(item);
      } else {
        this.editando = false;
        this.iniciarCreacion();
      }
      this.modal.show();
    },
    EventoCerrar() {
      this.cerrar();
    },
    // ---------------- Métodos internos ---------------
    cargarLocalidadesDeProvincia(provinciaId) {
      Api.Localidad.getLocalidadesDeProvincia(provinciaId).then(response => {
        this.localidades = response.data;
      });
    },
    /** Carga la lista de subcategorias para la categoría seleccionada */
    cargarSubcategoriasDeCategoria(categoriaId) {
      if (categoriaId) {
        Api.Categoria.getSubcategoriasDeCategoria(categoriaId).then(
          respuesta => {
            this.subcategoriaList = respuesta.data;
          }
        );

        this.categoriaId = categoriaId;
      }
      // Poner en null porque puede venir como ""
      else {
        this.categoriaId = null;
        this.subcategoriaList = [];
      }
    },
    cargarSubcategoriasHermanas(subcategoriaId) {
      if (subcategoriaId) {
        // Primero obtener categoría madre
        Api.Categoria.getCategoriaDeSubcategoria(subcategoriaId).then(resp => {
          this.cargarSubcategoriasDeCategoria(resp.data.id);
        });
      }
      // Limpiar ya que no hay subcategoría
      else this.cargarSubcategoriasDeCategoria(null);
    },
    // Cuando se selecciona en el select
    categoriaSeleccionada: async function(event) {
      this.cargarSubcategoriasDeCategoria(event.target.value);
      // Limpiar subcategoría
      this.setSubcategoria(null);
    },
    setSubcategoria(id) {
      this.item.beneficio.subcategoria.id = id;
    },
    // Cuando se selecciona en el select
    subcategoriaSeleccionada: async function(event) {
      this.setSubcategoria(event.target.value);
    },
    cerrar() {
      this.$emit(EVENTO_CERRADO);
      this.modal.hide();
    },
    clickCerrar() {
      this.cerrar();
    },
    clickGuardar() {
      // Si hay datos faltantes, no guardar
      if (this.DatosFaltantes != "") return;

      this.guardando = true;

      if (this.Editando) {
        // Las solicitudes usan el id de comercio para identificarse
        // itemEnServer contiene el dto final que fue guardado en el server,
        // Por ejemplo, trae el nombreLocalidad relleno con el nuevo valor
        Facade.update(this.item)
          .then(itemEnServer => {
            // Solo se guarda cuando es un logo nuevo y no el original
            if (this.estadoLogo == EstadoLogo.nuevo) {
              this.subirLogo(this.item.comercio.id)
                .then(response2 => {
                  // Guardar el nombre del logo
                  itemEnServer.logoUrl = response2.data.Name;
                  this.terminarEdicion(itemEnServer);
                })
                .catch(error => {
                  console.error(error);
                })
                .finally(() => {
                  this.guardando = false;
                });
            } else {
              this.guardando = false;
              this.terminarEdicion(itemEnServer);
            }
          })
          .catch(error => {
            console.error(error);
            this.guardando = false;
          });
      }
    },
    iniciarCreacion() {
      this.limpiarInputs();
      this.item = Util.copiaProfunda(ITEM_LIMPIO);
    },
    iniciarEdicion(item) {
      // Si no es de la misma subcategoría que el anterior
      if (
        item.beneficio != undefined &&
        item.beneficio.subcategoria != undefined
      ) {
        if (
          !this.item ||
          !this.item.beneficio.subcategoria ||
          this.item.beneficio.subcategoria.id != item.beneficio.subcategoria?.id
        ) {
          this.cargarSubcategoriasHermanas(item.beneficio.subcategoria.id);
        }
      }

      // Solo rellenar cosas si no se entró a editar el anterior
      if (this.item.comercio.id != item.comercio.id) {
        this.limpiarInputs();

        // Trabajar con una copia profunda para que no se apliquen los cambios directamente
        this.item = Util.copiaProfunda(item);

        if (item.comercio.logoUrl) {
          // Esto hará que el evento de agregado omita el agregado de logo
          this.estadoLogo = EstadoLogo.original;

          const urlAbsoluta = this.CarpetaLogos + item.comercio.logoUrl;

          this.$refs.cargadorImagen.EventoCargarURL(urlAbsoluta);
        }

        if (item.comercio.provincia) {
          this.cargarLocalidadesDeProvincia(item.comercio.provincia.id);
        }
      }
    },
    logoAgregado(archivo) {
      this.archivoLogo = archivo;

      // Cuando el estado es original es porque se triggereo este método
      // al agregar el logo original, por lo tanto no se debe hacer nada
      if (this.estadoLogo != EstadoLogo.original) {
        this.estadoLogo = EstadoLogo.nuevo;
      }
    },
    logoEliminado() {
      this.archivoLogo = null;
      this.estadoLogo = EstadoLogo.vacio;
    },
    provinciaCambiada: async function(event) {
      const provinciaId = event.target.value;

      this.item.comercio.provincia.id = provinciaId;

      this.item.comercio.localidad.id = null;

      if (provinciaId != null) {
        this.cargarLocalidadesDeProvincia(provinciaId);
      }
    },
    /**Limpia los inputs de creación/edición */
    limpiarInputs() {
      // Es necesario que no sea simplemente una borrada de campos
      // Ya que en tal caso dejarían de funcionar correctamente
      // los métodos en "computed"
      this.item = Util.copiaProfunda(ITEM_LIMPIO);

      // Borra el logo del input
      this.$refs.cargadorImagen.EventoLimpiar();
      this.estadoLogo = EstadoLogo.vacio;
    },
    subirLogo(idComercio) {
      console.log("Subiendo logo...");
      let formData = new FormData();
      formData.append("image", this.archivoLogo);
      return Api.Logos.subir(idComercio, formData, this.token);
    },
    localidadCambiada(localidad) {
      this.item.comercio.localidad.id = localidad.id;
    },
    terminarCreacion() {
      this.$emit(EVENTO_CREADO, this.item);
      this.cerrar();
    },
    terminarEdicion(itemEnServer) {
      this.$emit(EVENTO_EDITADO, itemEnServer);
      this.cerrar();
    }
  }
};
</script>
<style scoped>
*:not(h3) {
  font-size: 16px;
}
h2 {
  font-size: 24px;
}
h3 {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
#indicador-guardado {
  width: 16px;
  height: 16px;
}
.edicion .table-responsive table tr th {
  width: 30%;
}

.select-flotante label,
.logo-flotante label {
  width: 100%;
  margin-left: 10px;
  margin-bottom: 2px;
  font-size: 13.6px;
  text-align: left;
}
</style>
